export default __webpack_public_path__ + "static/media/LOGO JASARI@8x.ac060000.png";